import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
} from './clubs.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';


@Injectable()
export class ClubsRecordEffects {

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                const url = 'client-club';
                return this.crudServerService.fetchData(url,).pipe(
                    map( (response) => {
                        const club = response.data.club;
                        return fetchSingleRecordSuccess({singleData: club});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                // this.alertService.triggerAlert(error, "error");
                                this.routeService.triggerRoute(null, "/dashboard");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );
    
    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
    ) { }

}